import styled from 'styled-components';

import { basicTitleTextStyle, fonts } from '@dreryk/react-components';

export const StyledFormSectionHeader = styled.h3`
   margin: 0;
   ${basicTitleTextStyle}
   font-weight: ${fonts.fontWeightNormal};
`;

StyledFormSectionHeader.displayName = 'StyledFormSectionHeader';
